export const DELETE_CREDIT_CARD_START = 'DELETE_CREDIT_CARD_START';
export const DELETE_CREDIT_CARD_SUCCESS =
  'DELETE_CREDIT_CARD_SUCCESS';
export const DELETE_CREDIT_CARD_FAILURE =
  'DELETE_CREDIT_CARD_FAILURE';
